import { render, staticRenderFns } from "./quizpoints.vue?vue&type=template&id=5a40ff28&"
import script from "./quizpoints.vue?vue&type=script&lang=js&"
export * from "./quizpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports